// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getCommitmentReliability(projectId: String, startDate: string, endDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/commitmentreliability?from=${startDate}&to=${endDate}`);
}
